{
  "slug": "low-iq-scores-explained",
  "title": "Low IQ scores explained responsibly",
  "description": "Understand lower IQ score ranges, confidence intervals, adaptive functioning, and why a score alone never defines a person or establishes a diagnosis.",
  "summary": "A lower IQ result describes performance on selected tasks relative to a norm group. It requires careful, respectful interpretation alongside uncertainty, access needs, development, and everyday functioning.",
  "category": "IQ score interpretation",
  "sections": [
    {
      "heading": "What a lower score can and cannot mean",
      "paragraphs": [
        "On a mean-100, SD-15 scale, scores below 85 are below the population mean and scores near 70 are around two standard deviations below it. The precise percentile and classification depend on the instrument and norms.",
        "The result does not measure human worth, kindness, creativity, practical experience, or every ability. Language, education, sensory or motor access, health, attention, and testing conditions may affect performance."
      ]
    },
    {
      "heading": "A diagnosis is not made from IQ alone",
      "paragraphs": [
        "Professional evaluation of intellectual disability considers intellectual functioning together with adaptive functioning in conceptual, social, and practical life domains, with onset during the developmental period. A single online or screening score cannot establish that diagnosis.",
        "A qualified evaluator selects appropriate measures, considers accommodations and background, examines the confidence interval, and integrates information from more than one source."
      ]
    },
    {
      "heading": "Use results to understand support needs",
      "paragraphs": [
        "The constructive question is which tasks are easier or harder and what support improves participation. Clear instructions, extra time when appropriate, assistive technology, teaching, and environmental changes can matter.",
        "If a low result is unexpected or may affect services, discuss it with a qualified professional rather than repeatedly taking online tests or treating a cutoff as perfectly precise."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does an IQ below 70 automatically mean intellectual disability?",
      "answer": "No. Diagnosis also requires assessment of adaptive functioning and developmental history, using appropriate professional standards."
    },
    {
      "question": "Can testing conditions lower a score?",
      "answer": "Yes. Fatigue, illness, anxiety, language mismatch, distraction, access barriers, and other conditions can affect performance."
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "AAIDD — intellectual disability questions and answers",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
